fx.ns("models", class ProductType extends fx.Model {

	constructor(data)
	{
		super(data);
	}

    static BOOK = 1;
    static PRINT = 2;
    static FRAME = 3;
    static CALENDAR = 4;
    static POSTER = 5;

});